<template>
  <!-- ホルター心電図解析結果承認 -->
  <div id="HolterAnalysisReportUpdate">
    <div id="container">
      <holterNavi v-bind:pageid='"HolterAnalysisReportUpdate"'></holterNavi>
      <div class="labelTitle lable">判定医レポート作成</div>
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" v-model="receiptNumber" maxlength="20"  @keyup.enter="onKeyupEnter()"/></td>
          </tr>
        </table>
        <b-button class="addButton is-primary" @click="doSearch">検索</b-button>
      </div>
      <!-- 検索結果 -->
      <!-- <div class="result-area" v-if="hasResult" > -->
      <div id="item-contens" class="result-area" v-if="hasResult">
        <div class="card-content margin-top">
          <span style="font-size:20px;">患者情報</span>
          <table style="margin-bottom:10px;">
            <tr>
              <th colspan="4">受付番号：{{data.receiptNumber}}</th>
            </tr>
            <tr>
              <th colspan="4">依頼元：{{data.client}}</th>
            </tr>
            <tr>
              <th>ID</th>
              <td><input class="resultInput" type="text" v-model="data.id" maxlength="20"/></td>
              <th>生年月日：({{data.age}}歳)</th>
              <td><input class="resultInput inputArea" type="date" v-model="data.birthday" :max="yyyy_hyp_MM_hyp_dd(new Date())" name="生年月日" validate="date|birthDay"/></td>
            </tr>
            <tr>
              <th>患者名</th>
              <td><input class="resultInput" type="text" v-model="data.patientName" maxlength="100"/></td>
              <th>患者名カナ</th>
              <td><input class="resultInput" type="text" v-model="data.patientNameKana" maxlength="100"/></td>
            </tr>
            <tr>
              <th>身長</th>
              <td><input class="resultInput" type="text" v-model="data.height" maxlength="100"/>cm</td>
              <th>体重</th>
              <td><input class="resultInput" type="text" v-model="data.weight" maxlength="20"/>kg</td>
            </tr>
            <tr>
              <th>性別</th>
              <td>
                <div class="block">
                  <b-radio class="td_radio" v-model="data.gender" native-value="男">男</b-radio>
                  <b-radio class="td_radio" v-model="data.gender" native-value="女">女</b-radio>
                </div>
              </td>
              <th>ペースメーカーの有無</th>
              <td>
                <div class="block">
                  <b-radio class="td_radio" v-model="data.gender1" native-value="有">有</b-radio>
                  <b-radio class="td_radio" v-model="data.gender1" native-value="無">無</b-radio>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="card-content margin-top">
          <span style="font-size:20px;">レポート情報</span>
          <table style="margin-top:10px;margin-bottom:10px;">
            <tr>
              <th>記録時間</th>
              <td>
                <input style="width:22%;" type="text" v-model="data.cvhri" maxlength="20"/>日
                <input style="width:22%;" type="text" v-model="data.cvhri" maxlength="20"/>時間
                <input style="width:22%;" type="text" v-model="data.cvhri" maxlength="20"/>分
              </td>
              <th>検査日</th>
              <td><input class="resultInput inputArea" type="date" v-model="data.inspectionDate" :max="yyyy_hyp_MM_hyp_dd(new Date())" name="生年月日" validate="date|birthDay"/></td>
            </tr>
            <tr>
              <th v-if="!atLaunchHidden.hiddenFlag">CVHRI</th>
              <td v-if="!atLaunchHidden.hiddenFlag"><input class="resultInput" type="text" v-model="data.cvhri" maxlength="20"/>回</td>
              <th>Af値</th>
              <td><input class="resultInput" type="text" v-model="data.afValue" maxlength="20"/></td>
            </tr>
          </table>
        </div>
        <div class="card-content margin-top">
          <span style="font-size:20px;">解析情報</span>
          <table style="margin-top:10px;margin-bottom:10px;">
            <tr>
              <th>心拍数最大値</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>bpm</td>
              <th>心拍数最小値</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>bpm</td>
            </tr>
            <tr>
              <th>心拍数平均値</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>bpm</td>
            </tr>
            <!-- TODO: STEP2
            -->
            <tr></tr>
            <tr>
              <th>上室性期外収縮（単発、連発）</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>回</td>
              <th>上室性期外収縮（単発、連発）</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>％</td>
            </tr>
            <tr>
              <th>上室性期外収縮（単発）</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>回</td>
              <th>上室性期外収縮（連発）</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>回</td>
            </tr>
            <!-- TODO: STEP2
            -->
            <tr></tr>
            <tr>
              <th>心室性期外収縮</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>回</td>
              <th>心室性期外収縮</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>％</td>
            </tr>
            <tr>
              <th>心室性期外収縮（単発）</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>回</td>
              <th>心室性期外収縮（連発）</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>回</td>
            </tr>
            <!-- TODO: STEP2
            -->
            <tr></tr>
            <tr>
              <th>心室性期外収縮（多源性）</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>回</td>
            </tr>
            <tr>
              <th>心室性期外収縮（２段脈）</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>回</td>
              <th>心室性期外収縮（２段脈）</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>％</td>
            </tr>
            <tr>
              <th>心室性期外収縮（3段脈）</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>回</td>
              <th>心室性期外収縮（3段脈）</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>％</td>
            </tr>
            <!-- TODO: STEP2
            -->
            <tr></tr>
            <tr>
              <th>洞調律</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>bpm</td>
              <th>心房細動/フラッター</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>％</td>
            </tr>
            <tr>
              <th>心房細動/フラッター</th>
              <td>
                <input style="width:22%;" type="text" v-model="data.cvhri" maxlength="20"/>日
                <input style="width:22%;" type="text" v-model="data.cvhri" maxlength="20"/>時間
                <input style="width:22%;" type="text" v-model="data.cvhri" maxlength="20"/>分
              </td>
              <th>心房細動/フラッター</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>bpm</td>
            </tr>
            <!-- TODO: STEP2
            -->
            <tr></tr>
            <tr>
              <th>その他上室性頻拍</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>％</td>
              <th>その他上室性頻拍</th>
              <td>
                <input style="width:22%;" type="text" v-model="data.cvhri" maxlength="20"/>日
                <input style="width:22%;" type="text" v-model="data.cvhri" maxlength="20"/>時間
                <input style="width:22%;" type="text" v-model="data.cvhri" maxlength="20"/>分
              </td>
            </tr>
            <tr>
              <th>その他上室性頻拍</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>bpm</td>
            </tr>
            <!-- TODO: STEP2
            -->
            <tr></tr>
            <tr>
              <th>洞停止</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>回</td>
              <th>洞停止</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>秒</td>
            </tr>
            <tr>
              <th>房室ブロック</th>
              <td>
                <select class="judgeSelect" v-model="data.judgmentNum">
                  <option></option>
                  <option value="0">完全房室ブロック（Ⅲ度）</option>
                  <option value="1">高度房室ブロック</option>
                  <option value="2">Ⅱ度房室ブロック（モビッツⅡ型）</option>
                  <option value="3">Ⅱ度房室ブロック（ウェンケバッハ型）</option>
                  <option value="4">未定義（Ⅰ度？）</option>
                </select>
              </td>
              <th>房室ブロック</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>秒</td>
            </tr>
            <!-- TODO: STEP2
            -->
            <tr></tr>
            <tr>
              <th>心室頻拍</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>回</td>
              <th>心室頻拍</th>
              <td>
                <input style="width:35%;" type="text" v-model="data.cvhri" maxlength="20"/>時間
                <input style="width:35%;" type="text" v-model="data.cvhri" maxlength="20"/>分
              </td>
            </tr>
            <tr>
              <th>心室頻拍</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>bpm</td>
            </tr>
            <!-- TODO: STEP2
            -->
            <tr></tr>
            <tr>
              <th>その他の不整脈</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>回</td>
              <th>その他の不整脈</th>
              <td>
                <input style="width:35%;" type="text" v-model="data.cvhri" maxlength="20"/>時間
                <input style="width:35%;" type="text" v-model="data.cvhri" maxlength="20"/>分
              </td>
            </tr>
            <tr>
              <th>その他の不整脈</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>bpm</td>
            </tr>
            <!-- TODO: STEP2
            -->
            <tr></tr>
            <tr>
              <th>徐脈</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>回</td>
              <th>徐脈</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>％</td>
            </tr>
            <tr>
              <th>頻脈</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>回</td>
              <th>頻脈</th>
              <td><input class="resultInput" type="text" v-model="data.xxxx" maxlength="20"/>％</td>
            </tr>
            <!-- TODO: STEP2
            -->
            <tr></tr>
            <tr>
              <th>ST-T異常</th>
              <td>
                <div class="block">
                  <b-radio class="td_radio" v-model="data.gender2" native-value="あり">あり</b-radio>
                  <b-radio class="td_radio" v-model="data.gender2" native-value="なし">なし</b-radio>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="card-content margin-top">
          <span style="font-size:20px;">判定情報</span>
          <table style="margin-top:10px;margin-bottom:10px;">
            <tr>
              <th>判定医医療機関</th>
              <td><input class="resultInput" type="text" v-model="data.judgmentHospital" maxlength="100"/></td>
              <th>判定医名</th>
              <td><input class="resultInput" type="text" v-model="data.judgmentDoctor" maxlength="100"/></td>
            </tr>
            <tr>
              <th>判定結果</th>
              <td>
                <select class="judgeSelect" v-model="data.judgment">
                  <option></option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                  <option value="E">E</option>
                </select>
              </td>
            </tr>
            <tr v-if="data.judgment=='D'">
              <th style="vertical-align:top;">判定結果(詳細)</th>
              <td colspan="3">
                <b-checkbox style="width: 26px" v-model="data.judgment"/>心エコー
                <b-checkbox style="width: 26px" v-model="data.judgment"/>心運動負荷心電図
                <b-checkbox style="width: 26px" v-model="data.judgment"/>心筋シンチ
                <b-checkbox style="width: 26px" v-model="data.judgment"/>カテコラミン
                <b-checkbox style="width: 26px" v-model="data.judgment"/>甲状腺ホルモン
                <b-checkbox style="width: 26px" v-model="data.judgment"/>血清電解質
                <b-checkbox style="width: 26px" v-model="data.judgment"/>ジキタリス濃度
              </td>
            </tr>
            <tr>
              <th colspan="2">行動記録メモの異常症状およびイベントボタン操作</th>
              <td>
                <div class="block">
                  <b-radio class="td_radio" v-model="data.gender2" native-value="あり">あり</b-radio>
                  <b-radio class="td_radio" v-model="data.gender2" native-value="なし">なし</b-radio>
                </div>
              </td>
            </tr>
            <tr>
              <th style="vertical-align:top;" rowspan="2">判定医コメント</th>
              <td><b-checkbox style="width: 26px" v-model="data.judgment"/>判定医コメント(特記事項なし)
                </td>
            </tr>
            <tr>
              <td colspan="3"><textarea maxlength="256" style="resize:vertical;max-width:95%;height:100px;" v-model="data.memo"></textarea></td>
            </tr>
          </table>
        </div>
        <div class="card-content margin-top">
          <table style="margin-top:10px;margin-bottom:10px;">
            <tr>
              <th>患者レポート</th>
              <td>
                <span><b-icon icon="paperclip"/></span><a @click="deleteUpfile(index)">ｘｘｘｘ.pdf</a>
              </td>

              <th>判定医レポート</th>
              <td colspan="3">
                <span><b-icon icon="paperclip"/></span><a @click="deleteUpfile(index)">ｘｘｘｘ.pdf</a>
              </td>
            </tr>
          </table>
        </div>
        <div class="button-area">
          <b-button class="is-primary replaceButton" @click="replace">患者レポート差し替え</b-button>
          <b-button class="is-primary replaceButton" @click="replace">判定医レポート差し替え</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/holterAnalysis/HolterAnalysisNaviBar";
import {atLaunchHidden} from "@/components/mock/base/const.js";

export default {
  name: "HolterAnalysisReportUpdate",
  methods: {
    doSearch: function() {
      //if(!this.receiptNumber){
      //  this.showErrorMessage("受付番号を入力してください。")
      //  return;
      //}
      this.data = {}
      this.hasResult = false;
      this.nowdate = new Date();

      this.data = {
        receiptNumber: '1235',
        client:'どこかから依頼',
        id: '12345',
        age: '2023-01-19',
        birthday: '2023-01-19',
        patientName: '山田 太郎',
        patientNameKana: 'ヤマダ タロウ',
        height: '170cm',
        weight: '50kg',
        gender1: '有',
        gender2: 'あり',
        cvhri: '2023-01-19',
        inspectionDate: '2023-01-19',
        afValue: 5,
        xxxx: 6,
        judgmentNum: 0,
        judgmentHospital: '鈴木医院',
        judgmentDoctor:　'Dr.鈴木',
        judgment: 'A',
        memo: '昨年から治療中'        
      }
      this.hasResult = true;

      //var excuteApi = this.getHolterAnalysisResultApprovalListPOST;
      //var successCallBack = this.getHolterAnalysisResultApprovalListPOSTSuccess;
      //var errorCallBack = this.getHolterAnalysisResultApprovalListPOSTError;
      // Web Api Call
      //this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterAnalysisResultApprovalListPOST: function(client) {
      return client.apis.internalHolterAnalysis.getHAnalysisResultApprovalListPOST({
        body:this.receiptNumber
      });
    },
    getHolterAnalysisResultApprovalListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.hasResult = true;
    },
    getHolterAnalysisResultApprovalListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    }
  },
  data() {
    return {
      receiptNumber:"",
      data: {},
      hasResult: false,
      atLaunchHidden: atLaunchHidden
    };
  },
  async mounted() {},
  filters: {},
  components: {
    holterNavi: naviBar
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.tag {
  width: 80px;
}
.condition-area {
    display: flex;
}
.conditionTable {
  width: 400px;
}
.addButton {
    margin-left:20px;
}
.resultInput {
  width: 260px !important;
}
.judgeSelect {
  width: 260px !important;
}
.replaceButton {
  margin-right:5%;
  width:22% !important;
}
#item-contens table tr th{
  width: 220px;
  padding-top:10px;
  padding-left:10px;
}
#item-contens table tr td{
  width: 280px;
  padding-top:10px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/holterAnalysis/HolterAnalysisReportUpdate.vue